import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Slides } from 'ionic-angular';
import { BusquedaTesoroNivelesPage } from '@pages';
import { BusquedaTesoroProvider } from '@providers/busqueda-tesoro/busqueda-tesoro';

@IonicPage()
@Component({
  selector: 'page-busqueda-tesoro-instrucciones',
  templateUrl: 'busqueda-tesoro-instrucciones.html',
})
export class BusquedaTesoroInstruccionesPage {

  @ViewChild(Slides) slides: Slides;
  busquedaTesoro: any;
  muestraPrimePremio: boolean;

  readonly AUDIO_PRIMER_PREMIO = 'assets/audios/busqueda-tesoro/primer-premio.mp3';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private busquedaTesoroProvider: BusquedaTesoroProvider,
  ) {
    this.busquedaTesoro = this.navParams.get('busquedaTesoro');
    this.muestraPrimePremio = false;
  }

  ionViewDidLoad() {
  }

  next() {
    if(this.slides.isEnd()) {
      this.muestraPrimePremio = true;

      let audio = new Audio();
      audio.src = this.AUDIO_PRIMER_PREMIO;
      audio.load();
      audio.play();
    } else {
      this.slides.slideNext();
    }
  }

  goTo() {
    this.busquedaTesoroProvider.actualizaMuestraInstrucciones(true);
    this.navCtrl.setRoot(BusquedaTesoroNivelesPage, {
      busquedaTesoro: this.busquedaTesoro
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-instrucciones/busqueda-tesoro-instrucciones.ts